export enum RouteBuilderPermissions {
  ViewBuilder = 'builder:view',
  LegCreate = 'builder:leg:create',
  LegDelete = 'builder:leg:delete',
  AirLegEdit = 'builder:leg:airEdit',
  GroundLegEdit = 'builder:leg:groundEdit',
  AssignResource = 'builder:assign:resource',
  AlgorithmView = 'builder:algorithm:view',
  AlgorithmApply = 'builder:algorithm:apply',
  LogView = 'builder:log:view',
  DeviceTrackingLogView = 'builder:device-tracking-log:view',
  ActionSendToAviationApprove = 'builder:action:sendToAviationApprove',
  ActionAviationApprove = 'builder:action:aviationApprove',
  ActionSendToGroundApprove = 'builder:action:sendToGroundApprove',
  ActionGroundApprove = 'builder:action:groundApprove',
  ActionRouteComplete = 'builder:action:routeComplete',
  ActionBookResources = 'builder:action:bookResources',
  ActionReviewAirQuote = 'builder:action:reviewAirQuote',
  ActionReviewGroundQuote = 'builder:action:reviewGroundQuote',
  ActionRecallAirQuote = 'builder:action:recallAirQuote',
  ActionRecallGroundQuote = 'builder:action:recallGroundQuote',
  ActionSendQuoteInternal = 'builder:action:sendQuoteInternal',
  ActionSendQuote = 'builder:action:sendQuote',
  ActionApproveQuoteByTx = 'builder:action:approveQuoteByTx',
  ActionLightsAndSirensView = 'builder:action:lightsAndSirens:view',
  ActionLightsAndSirensHandle = 'builder:action:lightsAndSirens:handle',
  ActionNonStopFlightView = 'builder:action:nonStopFlight:view',
  ActionNonStopFlightHandle = 'builder:action:nonStopFlight:handle',
}

export enum CaseDetailsPermissions {
  CaseRead = 'case:read',
  CaseStatusUpdate = 'case:status:update',
  CaseGeneralUpdate = 'case:general:update',
  CaseDAGeneralUpdate = 'case:general:da:update',
  CaseDonorUpdate = 'case:donor:update',
  CaseDADonorUpdate = 'case:donor:da:update',
  CaseRetrievalUpdate = 'case:retrieval:update',
  CaseDARetrievalUpdate = 'case:retrieval:da:update',
  NoteUpdate = 'case:note:update',
  CaseAttachmentsRead = 'case:attachments:read',
  CaseAttachmentsCreate = 'case:attachments:create',
  CaseAttachmentsUpdate = 'case:attachments:update',
  CaseAttachmentsDelete = 'case:attachments:delete',
  AssignedResourcesUpdate = 'case:resource:update',
  ClinicalDataRead = 'case:clinical:read',
  CaseLogsRead = 'case:logs:read',
  SurgeonCompletionRead = 'case:clinical:surgeonform:read',
  ResourceStatusUpdate = 'case:resource:status:update',
  ResourceConsoleStatusUpdate = 'case:resource:console:status:update',
  OrgansRecoveredUpdate = 'case:organs:update',
  OrgansRecoveredDAUpdate = 'case:organs:da:update',
  LogisticsPanelRead = 'case:logistics:read',
  TripDetailsRead = 'case:trip:read',
  CasePilotsRead = 'case:pilots:read',
  CasePilotsPhoneNumberRead = 'case:pilots:phonenumber:read',
  CaseSyncDataCreate = 'case:syncData:create',
  CaseSyncDataRead = 'case:syncData:read',
  CaseTrialWarningRead = 'case:trialWarning:read',
  CaseQuoteRead = 'case:quote:read',
  CaseSCSMethodUpdate = 'case:scsMethod:update',
  OwnCaseScsMethodUpdate = 'ownCase:scsMethod:update',
  TrialQuestionnaireUpdate = 'case:trialQuestionnaire:update',
  TrialQuestionnaireRead = 'case:trialQuestionnaire:read',
  LocationTrackingRead = 'case:locationTracking:read',
  LocationTrackingUpdate = 'case:locationTracking:update',
  OpoDonorDataUpdate = 'case:opo:donorData:update',
  KidneyTrialUpdate = 'case:kidneyTrial:update',
  OwnCaseKidneyTrialUpdate = 'ownCase:kidneyTrial:update',
  KidneyRandomizationUpdate = 'case:kidneyRandomization:update',
  OwnCaseKidneyRandomizationUpdate = 'ownCase:kidneyRandomization:update',
}

export enum CaseBoardPermissions {
  CaseBoardRead = 'caseBoard:read',
  CaseBoardUpdate = 'caseBoard:update',
  CaseDraftCreate = 'caseBoard:draft:create',
  CaseDraftUpdate = 'caseBoard:draft:update',
  CaseDraftDelete = 'caseBoard:draft:delete',
}

export enum ArchiveCasesPermissions {
  ViewArchive = 'archive:view',
  CaseArchiveAccess90DaysRead = 'archive:access:read:90days',
  CaseArchiveAccess90DaysCreate = 'archive:access:create:90days',
  CaseArchiveAccess90DaysDelete = 'archive:access:delete:90days',
  CaseArchiveAccessIndefiniteRead = 'archive:access:read:indefinite',
  CaseArchiveAccessIndefiniteCreate = 'archive:access:create:indefinite',
  CaseArchiveAccessIndefiniteDelete = 'archive:access:delete:indefinite',
}

export enum AdminPermissions {
  TmdxUsersView = 'admin:tmdxUsers:view',
  TmdxUsersUpdate = 'admin:tmdxUsers:all:update',
  TmdxUsersCLUpdate = 'admin:tmdxUsers:cl:update',
  TmdxUsersCSUpdate = 'admin:tmdxUsers:cs:update',
  TmdxUsersCSUpdateTrialProgram = 'admin:tmdxUsers:cs:update-trial-program',
  TmdxUsersUpdateRoles = 'admin:tmdxUsers:update-roles',
  TmdxUsersAssignOfferCoordinator = 'admin:tmdxUsers:assign-offer-coordinator',
  TxCenterCreate = 'admin:txCenter:create',
  TxCenterUpdateNotes = 'admin:txCenter:update-notes',
  TxCenterUpdateQadCustomerId = 'admin:txCenter:update-qad-customer-id',
  TxCenterView = 'admin:txCenter:view',
  OpoCreate = 'admin:opo:create',
  OpoView = 'admin:opo:view',
  HospitalCreate = 'admin:hospital:create',
  HospitalView = 'admin:hospital:view',
  OcsConsolesCreate = 'admin:ocsConsoles:create',
  OcsConsolesView = 'admin:ocsConsoles:view',
  OcsConsolesUpdate = 'admin:ocsConsoles:update',
  OcsConsolesDelete = 'admin:ocsConsoles:delete',
  OcsPerfusionsSetsView = 'admin:ocsPerfusionsSets:view',
  NopHubCreate = 'admin:nopHub:create',
  NopHubView = 'admin:nopHub:view',
  NopHubRemove = 'admin:nopHub:remove',
  RegionsRead = 'admin:regions:read',
  RegionsUpdate = 'admin:regions:update',
  ProvidersConfigurationCreate = 'admin:providers:configurations:create',
  ProvidersConfigurationView = 'admin:providers:configurations:view',
  ProvidersConfigurationUpdate = 'admin:providers:configurations:update',
  AdminView = 'admin:view',
}

export enum SchedulerPermissions {
  ScheduleRead = 'scheduler:read',
  CCMyScheduleRead = 'read:cc:my:schedule',
  CCMyScheduleWrite = 'write:cc:my:schedule',
  CCSchedulesRead = 'read:cc:schedules',
  CCSchedulesWrite = 'write:cc:schedules',
  CCSchedulesSettingsRead = 'read:cc:schedules:settings',
  CCSchedulesSettingsWrite = 'write:cc:schedules:settings',
  CCSchedulesFixationTypeWrite = 'write:cc:schedules:fixation-type',
  CSSchedulesRead = 'read:cs:schedules',
  CSSchedulesWrite = 'write:cs:schedules',
  CSSchedulesSettingsRead = 'read:cs:schedules:settings',
  CSSchedulesSettingsInputsWrite = 'write:cs:schedules:settings:inputs',
  CSSchedulesSettingsRulesWrite = 'write:cs:schedules:settings:rules',
  CSSchedulesRestPeriodWrite = 'write:cs:schedules:rest-period',
  CSSchedulesFixationTypeWrite = 'write:cs:schedules:fixation-type',
  SSchedulesRead = 'read:s:schedules',
  SSchedulesWrite = 'write:s:schedules',
  SLiSchedulesWrite = 'write:s:li:schedules',
  SHtLuSchedulesWrite = 'write:s:htlu:schedules',
  SSchedulesSettingsRead = 'read:s:schedules:settings',
  SSchedulesSettingsWrite = 'write:s:schedules:settings',
  SSchedulesRestPeriodWrite = 'write:s:schedules:rest-period',
  SLiSchedulesRestPeriodWrite = 'write:s:li:schedules:rest-period',
  SHtLuSchedulesRestPeriodWrite = 'write:s:htlu:schedules:rest-period',
  SSchedulesFixationTypeWrite = 'write:s:schedules:fixation-type',
  OMSSchedulesRead = 'read:oms:schedules',
  OMSSchedulesWrite = 'write:oms:schedules',
  OMSSchedulesSettingsRead = 'read:oms:schedules:settings',
  OMSSchedulesSettingsInputsWrite = 'write:oms:schedules:settings:inputs',
  OMSSchedulesSettingsRulesWrite = 'write:oms:schedules:settings:rules',
  OMSSchedulesFixationTypeWrite = 'write:oms:schedules:fixation-type',
}

export enum InvoicePermissions {
  ReadInvoice = 'invoice:read',
}

export enum ChatViewPermissions {
  ViewChat = 'chat:view',
}

export enum ProfilePermissions {
  ProfileRead = 'profile:read',
  ProfileUpdate = 'profile:update',
}

export enum BulkAssignmentPermissions {
  ViewBulkAssignment = 'bulkAssignment:view',
  UpdateBulkAssignment = 'bulkAssignment:update',
}

export enum NotificationToastPermissions {
  ViewToastWithEventNameCaseResourceAssigned = 'toast:caseResourceAssigned:view',
  ViewToastWithEventNameCaseStatusUpdatedAndNewStatusResourcesDeployed = 'toast:caseStatusUpdated:resourcesDeployed:view',
  ViewToastWithEventNameCaseStatusUpdatedAndNewStatusCaseDeclined = 'toast:caseStatusUpdated:caseDeclined:view',
  ViewToastWithEventNameCaseStatusUpdatedAndNewStatusClinicalScreening = 'toast:caseStatusUpdated:clinicalScreening:view',
  ViewToastWithEventNameCaseStatusUpdatedAndNewStatusTransplantIsNotCompleted = 'toast:caseStatusUpdated:transplantIsNotCompleted:view',
  ViewToastWithEventNameCaseStatusUpdatedAndNewStatusCaseFinished = 'toast:caseStatusUpdated:caseFinished:view',
  ViewToastWithEventNameCaseStatusUpdatedAndNewStatusCaseFinishedAndOldStatusTransplantIsNotCompleted = 'toast:caseStatusUpdated:transplantIsNotCompleted:caseFinished:view',
  ViewToastWithEventNameCaseStatusUpdatedAndNewStatusPendingLogistics = 'toast:caseStatusUpdated:pendingLogistics:view',
  ViewToastWithEventNameCaseStatusUpdatedAndNewStatusResourcesAssigned = 'toast:caseStatusUpdated:resourcesAssigned:view',
  ViewToastWithEventNameCaseStatusUpdatedAndNewStatusOnOCS = 'toast:caseStatusUpdated:onOCS:view',
  ViewToastWithEventNameOrganAcceptanceCriteriaUpdated = 'toast:organAcceptanceCriteriaUpdated:view',
  ViewToastWithEventNameOrganApprovalUpdated = 'toast:organApprovalUpdated:view',
  ViewToastWithEventNameCaseDetailsUpdated = 'toast:caseDetailsUpdated:view',
  ViewToastWithEventNameResourceStatusUpdated = 'toast:resourceStatusUpdated:view',
  ViewToastWithEventNameTBD = 'toast:TBD:view',
  ViewToastWithEventNameMAOTripCreationFailed = 'toast:MAOTripCreationFailed:view',
  ViewToastWithEventNameCaseResourceReserved = 'toast:caseResourceReserved:view',
  ViewToastWithEventNameCaseReviewUpdated = 'toast:caseReviewUpdated:view',
  ViewToastWithEventNameCaseRouteUpdated = 'toast:caseRouteUpdated:view',
  ViewToastWithEventNameCaseQuoteRejectedInternally = 'toast:caseQuoteRejectedInternally:view',
  ViewToastWithEventNameCaseQuoteCreated = 'toast:caseQuoteCreated:view',
  ViewToastWithEventNameCaseQuoteApprovedByTxCenter = 'toast:caseQuoteApprovedByTxCenter:view',
  ViewToastWithEventNameCaseQuoteRejectedByTxCenter = 'toast:caseQuoteRejectedByTxCenter:view',
  ViewToastWithEventNameCaseQuoteSentToTxCenter = 'toast:caseQuoteSentToTxCenter:view',
  ViewToastWithEventNameCaseResourceInvitationDeclined = 'toast:caseResourceInvitationDeclined:view',
  ViewToastWithEventNameCaseQuoteApprovedInternally = 'toast:caseQuoteApprovedInternally:view',
  ViewToastWithEventNameCaseQuoteApprovedTxCenterProvider = 'toast:caseQuoteApprovedTxCenterProvider:view',
  ViewToastWithEventNameRoutePlanningStatusUpdatedAndNewStatusWaitingForAviationApproval = 'toast:routePlanningStatusUpdated:waitingForAviationApproval:view',
  ViewToastWithEventNameRoutePlanningStatusUpdatedAndNewStatusBookingPending = 'toast:routePlanningStatusUpdated:bookingPending:view',
}

export enum MultiCaseSuggestPermissions {
  ReadMCS = 'multiCaseSuggest:read',
  CreateCMS = 'multiCaseSuggest:create',
  ReviewsReadMCS = 'multiCaseSuggest:reviews:read',
  ReviewsCreateMCS = 'multiCaseSuggest:reviews:create',
}

export enum ReleaseNotesPermissions {
  Read = 'read:release-notes',
  Write = 'write:release-notes',
}
